import { ReactiveVar } from '@apollo/client'
import { GridApi } from 'ag-grid-community'
import IconAsc from 'assets/icons/context-menu/ascending.svg'
import IconClearSort from 'assets/icons/context-menu/clear-sort.svg'
import IconDesc from 'assets/icons/context-menu/descending.svg'
import IconSortBy from 'assets/icons/context-menu/sort-by.svg'

export const sortBy = (gridApi: GridApi, colId: string, closeMenuVar: ReactiveVar<any>) => {
  return {
    content: 'Sort By',
    icon: IconSortBy,
    items: [
      {
        icon: IconAsc,
        content: 'Ascending',
        onClick: () => {
          closeMenuVar(false)
          if (gridApi && colId) {
            return gridApi.applyColumnState({
              state: [{ colId, sort: 'asc' }],
              defaultState: { sort: null },
            })
          }
        },
      },
      {
        icon: IconDesc,
        content: 'Descending',
        onClick: () => {
          closeMenuVar(false)
          if (gridApi && colId) {
            return gridApi.applyColumnState({
              state: [{ colId, sort: 'desc' }],
              defaultState: { sort: null },
            })
          }
        },
      },
      {
        icon: IconClearSort,
        content: 'Clear Sort',
        onClick: () => {
          closeMenuVar(false)
          if (gridApi) {
            // Clear all column sorts explicitly
            return gridApi.applyColumnState({
              state: gridApi.getColumnState().map((col) => ({
                colId: col.colId,
                sort: null,
              })),
              defaultState: { sort: null },
            })
          }
        },
      },
    ],
  }
}
